import React from 'react';
import { Grid, Skeleton } from '@mui/material';

const ProductSkeleton = () => {
  return (
    <Grid container mt={1} spacing={3}>
      {[...new Array(12)].map(() => (
        <Grid item xl={2} lg={3} md={4} sm={6} xs={12} key={Math.random()}>
          <Skeleton
            variant='circular'
            width='100%'
            height='280px'
            sx={{ borderRadius: '1rem', margin: '1rem' }}
          />
        </Grid>
      ))}
    </Grid>
  );
};

export default ProductSkeleton;
